import en from './locales/en.json'
import sk from './locales/sk.json'
import ua from './locales/ua.json'
import { getCookie } from '../../../utils/cookies'

export const defaultLocale = getCookie('locale') ? getCookie('locale') : 'sk'

export const languages = {
  en: en,
  sk: sk,
  ua: ua,
}

